import triggerService from '../../services/tickets/trigger.service.js'

import entityUtility from '../../utils/entity.utility.js'
import httpUtility from '../../utils/http.utility.js'

import { useToast } from '../../composables/useToast.js'

import { t } from '@/i18n'

const toast = useToast()

async function saveTrigger(scope, payload) {
  try {
    let response
    if (payload._id) response = await triggerService.update.trigger(scope, payload._id, payload)
    else response = await triggerService.create.trigger(scope, payload)
    return response.data.item
  } catch (err) {
    toast.error(httpUtility.error.message(err, t('tickets.settings.errors.saveTrigger')))
    return null
  }
}

async function updateTriggerActive(scope, id, active) {
  try {
    await triggerService.update.active(scope, String(id), active)
    return true
  } catch (err) {
    toast.error(httpUtility.error.message(err, t('tickets.settings.errors.saveTrigger')))
    return false
  }
}

async function deleteTrigger(scope, id) {
  try {
    await triggerService.delete.trigger(scope, id)
    return true
  } catch (err) {
    toast.error(httpUtility.error.message(err, t('tickets.settings.errors.deleteItem')))
    return false
  }
}

function findTrigger(id, array) {
  return entityUtility.find(id, array)
}

class TriggerController {
  /**
   * Look up one trigger by `id` in `array`. Returns the row, or `null`
   * when `id` is missing or not found.
   *
   * @param {string|null|undefined} id
   * @param {Array<{ _id: string }>} array
   * @returns {object|null}
   */
  find(id, array) {
    return findTrigger(id, array)
  }

  save = {
    /**
     * Create or update a trigger row. Branches on `payload._id`
     * (truthy → update; omitted → create). Returns the saved trigger on
     * success, `null` on failure (toasts the error).
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {object} payload
     * @returns {Promise<object|null>}
     */
    async trigger(scope, payload) {
      return saveTrigger(scope, payload)
    },
  }

  update = {
    /**
     * Toggle a trigger's active flag. Returns `true` on success, `false`
     * on failure (toasts the error).
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @param {boolean} active
     * @returns {Promise<boolean>}
     */
    async active(scope, id, active) {
      return updateTriggerActive(scope, id, active)
    },
  }

  delete = {
    /**
     * Delete a trigger row. Returns `true` on success, `false` on
     * failure (toasts the error).
     *
     * @param {string} scope - Settings API URL prefix (`ticket-account` or `ticket-group/:id`).
     * @param {string} id
     * @returns {Promise<boolean>}
     */
    async trigger(scope, id) {
      return deleteTrigger(scope, id)
    },
  }
}

export default new TriggerController()
